<template>
  <div>
    <label>Paid As: </label>
    <input-button-list
      :value="[counselor.payroll.paidAs]"
      label=""
      :allow-two-stack="false"
      :multiple="false"
      :options="[{ id: 'Contractor', display_label: 'Contractor' }, { id: 'Vendor', display_label: 'Vendor' }]"
      :force-full-width-inputs="false"
      @input="setPaidAs($event)"
    />
  </div>
</template>

<script>
import PayrollClient from '@/api/CounselorManagement/PayrollClient';
import InputButtonList from '@/components/inputs/InputButtonList.vue';

export default {
    name: 'PaidAsPicker',

    components: {
        InputButtonList,
    },
    props: {
        counselor: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            payrollClient: new PayrollClient(this.$http)
        }
    },
    methods: {
      async setPaidAs(event) {
        try {
          this.counselor.payroll.paidAs = event[0];
          await this.payrollClient.setPayroll(this.counselor.id, this.counselor.payroll.tier, this.counselor.payroll.paidAs);
        } catch (error) {
          console.error(error);
        }
      }
  }
}
</script>

<style lang="scss" scoped>

label {
    @include label;

    display: block;
    margin-bottom: 10px;
  }

</style>
